import {
  Components,
  formHelperTextClasses,
  formLabelClasses,
  inputBaseClasses,
  Theme,
} from '@mui/material';

export const textFieldOverrides: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      //formLabel
      [`.${formLabelClasses.root}`]: {
        fontSize: 14,
        fontWeight: 500,
      },
      [`.${formHelperTextClasses.root}`]: {
        fontSize: 14,
      },

      [`.${formLabelClasses.focused}`]: {
        color: theme.palette.text.primary + '!important',
      },
      [`.${formLabelClasses.asterisk}`]: {
        fontSize: 14,
        color: theme.palette.error.main,
        marginLeft: '4px',
      },
      //Input
      [`label + .${inputBaseClasses.root}`]: {
        marginTop: '24px',
      },
      [`.${inputBaseClasses.root}`]: {
        borderRadius: 12,
        border: '1px solid',
        background: theme.palette.background.input,
        borderColor: theme.palette.borders.main,
        padding: '10px 16px',
      },
      [`.${inputBaseClasses.input}`]: {
        padding: 0,
        color: theme.palette.text.primary,
        fontSize: 14,
        '&::placeholder': {
          color: theme.palette.text.disabled,
          opacity: 1,
        },
      },
      [`.${inputBaseClasses.focused}`]: {
        borderColor: theme.palette.primary.main + '!important',
      },
      [`.${inputBaseClasses.error}`]: {
        borderColor: theme.palette.error.main + '!important',
      },
    }),
  },
};
